// Persist.js
// Author: Willmer Barahona
// "Why Mr. Anderson? Why? Why do you persist?" - Agent Smith
// This script persists user input into the browser localstorage
// --------------------------------------------------------------

const Persist = {};
const response = {
  code: 0,
  message: '',
  content: {}
};
const exceptions = ['card_number', 'cvv_num', 'card_num', 'g-recaptcha-response']; // 'cardholder_fname', 'cardholder_lname'

// Check if objname exists in localstorage
// returns boolean
Persist.exists = (objname) => (localStorage[objname]) ? true : false;

// get objname from localstorage and return its value
Persist.get = (objname) => {
  if (!localStorage[objname]) {
    response.code = 0;
    response.message = `Object ${objname} does not exists`;
    response.content = '{}';
  } else {
    response.code = 1;
    response.message = `${objname} info retrieved successfuly`;
    response.content = localStorage.getItem(objname);
  }

  return response;
};

// Save new value to objname
Persist.save = (objname, val) => {

  try {
    localStorage.setItem(objname, val);
  } catch(e) {
    console.log(`Item could not be saved to local storage. Error: ${e}`);
  }
};

// Remove objname from localStorage
Persist.clearObj = (objname) => {

  try {
    localStorage.removeItem(objname);
  } catch(e) {
    console.log(`Item could not be cleared to local storage. Error: ${e}`);
  }
};

// Remove exceptions from the model
Persist.removeExceptions = (model) => {

  // for (let i = 0; i < exceptions.length; i++) {
  //   if (model[exceptions[i]]) {
  //     delete model[exceptions[i]];
  //   }
  // }

  exceptions.map(item => {
    model[exceptions[item]] && delete model[exceptions[item]];
  });
};

export default Persist;



// WEBPACK FOOTER //
// ./js/modules/persist.js